
<template>
  <div class="cbody1">

      <router-link to="/price" class="alltitle">
         <p class="p1">{{webname}}</p>
         <div class="xian"></div>
         <p class="p2" v-html="webkey"></p><div class="xian"></div>
         <p class="p3">Price List ></p>
      </router-link>
      <div class="inprobox">
           <div class="prolist">
               <div class="imgbox">
                  <img :src="listData[0].content.img">
               </div>
               <p class="p1">{{listData[0].name}}</p>
               <p class="p2">{{listData[0].content.subtitle}}</p>
               <router-link class="a1" to="/price">Details &gt;</router-link>
           </div>   
           <div class="box1">
              <img :src="huaimg" alt="" class="icon">
              <div class="sbox">
              <p class="p1">ONE TIME CHARGE</p>
              <div class="xian"></div>
              <p class="p2">No Package</p>
            </div>
           </div> 
           <div class="box2">
              <div class="tbox">
                   <p class="p1">All Luxury Skin Care</p>
                   <div class="xian"></div>
                   <router-link class="a1" to="/product">Read More ></router-link>
              </div>
           </div>  
           <div class="prolist">
               <div class="imgbox">
                  <img :src="listData[1].content.img">
               </div>
               <p class="p1">{{listData[1].name}}</p>
               <p class="p3">{{listData[1].content.keywords}}</p>
               <router-link class="a1" to="/price">Details &gt;</router-link>
           </div> 

      </div>
  </div>
</template>

<script>
import { Recommend} from '../../api/userMG'


export default {
  name:'index',
  data() {
    return {
      huaimg:require("@/assets/img/hua4.png"),
        webname:'nomomo',
      webkey:'激光脫毛</br>​激光淡斑祛印',
      listData:[
      {
          name:'',
          content:{
            img:'',
            subtitle:''}
         },
         {
          name:'',
          content:{
            img:'',
            subtitle:''}
         }

      ],
     

      params:{
        mt_id:1
      },
      params2:{
        status:1,
        client_id:'1'
      }
    }
  },
  // 註冊組件
  components: {
   

    
  },
  /**
   * 數據發生改變
   */

  /**
   * 創建完畢
   */
  created() {
    
  },
  mounted() {
    this.getdata(this.params)

},
  /**
   * 裏麵的方法隻有被調用才會執行
   */
  methods: {
    // 獲取公司列錶
    getdata(parameter) {
      this.loading = true
    

      Recommend(parameter)
        .then(res => {
          this.loading = false
    
          if (res.data.code != 1) {
            this.$message({
              type: 'info',
              message: res.data.message
            })
          } else {
            res.data.data.data.forEach(el => {
              el.content=JSON.parse(el.content)
          
            });
            this.listData = res.data.data.data

          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜單加載失敗，請稍後再試！')
        })
    }
   
  }
}
</script>


 
 


// WEBPACK FOOTER //
// src/views/home/index.vue